module.exports = {
          srcSet: __webpack_public_path__ + "ab2eb3d0.jpg"+" 700w"+","+__webpack_public_path__ + "5814deec.jpg"+" 1400w"+","+__webpack_public_path__ + "b12028af.jpg"+" 1920w",
          images:[ {path: __webpack_public_path__ + "ab2eb3d0.jpg",width: 700,height: 525},{path: __webpack_public_path__ + "5814deec.jpg",width: 1400,height: 1050},{path: __webpack_public_path__ + "b12028af.jpg",width: 1920,height: 1440}],
          src: __webpack_public_path__ + "ab2eb3d0.jpg",
          toString:function(){return __webpack_public_path__ + "ab2eb3d0.jpg"},
          
          width: 700,
          height: 525
        }